/**
 * 功能：销售中心
 */
import { Directory } from './directory'
import { DirectorySubtitle } from './directorySubtitle'
import { DirectoryAssembly } from './directoryAssembly'
import { CategoryConfigServer } from './categoryConfig'
import { PartialServer } from './partial'
import { OrderServer } from './order'
import { GradeService } from './grade'
import { SmallDirectoryService } from './smallDirectory'
import { ReceiptServer } from './receipt'
import { DeliveryServer } from './delivery'
import { RefundServer } from './refund'
import { ClassServer } from './class'
import { StudentServer } from './student'
import { BookServer } from './book'
import { DirectoryMarkServer } from './directoryMark'
import { BroadcastService } from './broadcast'
import { BookingAndReleaseService } from './bookingAndRelease'
import { ordinaryBillOfLadingService } from './ordinaryBillOfLading'
import { PriceServer } from './price'
import { PayMentServer } from './payment'
import { DiscountServer } from './discount'
import { DirectoryBookServer } from './directoryBook'
import { TextbookDirectoryServer } from './textBookDirectory'
import { OrderChangeServer } from './changeOrder'
import { InventoryDetailsServer } from './inventoryDetails'
import { OccupationServer } from './occupation'
import { IntoAndManagementService } from './intoAndManagement'
import { SalesDeliveryServer } from './salesDelivery'
import { ShipmentPackageDetailsServer } from './shipmentPackageDetails'

export const orderChangeServer = new OrderChangeServer('/api/order/change')
export const directory = new Directory('/api/order/directory')
export const bookMenBuPage = new BookServer('/api/order/bookMenu')
export const directoryMark = new DirectoryMarkServer('/api/order/directoryMark')
export const directorySubtitle = new DirectorySubtitle('/api/order/directorySubtitle')
export const directoryAssembly = new DirectoryAssembly('/api/order/directoryAssembly')
export const categoryConfig = new CategoryConfigServer('/api/order/categoryConfig')
export const bookingAndRelease = new BookingAndReleaseService('/api/order/pre')
export const ordinaryBillOfLading = new ordinaryBillOfLadingService('/api/order/release')
export const partial = new PartialServer('/api/order/partial')
export const order = new OrderServer('/api/order')
export const grade = new GradeService('/api/order/grade')
export const smallDirectory = new SmallDirectoryService('/api/order/smallDirectory')
export const receipt = new ReceiptServer('/api/order/receipt')
export const delivery = new DeliveryServer('/api/order/delivery')
export const refund = new RefundServer('/api/order/refund')
export const aClass = new ClassServer('/api/order/class')
export const student = new StudentServer('/api/order/student')
export const discount = new DiscountServer('/api/order/discount')
export const directoryBook = new DirectoryBookServer('/api/order/directoryBook')
export const textbookDirectory = new TextbookDirectoryServer('/api/order/textbookDirectory')

export const price = new PriceServer('/api/order/price')
export const payment = new PayMentServer('/api/order/payment')

export const broadcast = new BroadcastService('/api/order/broadcast')
export const inventoryDetails = new InventoryDetailsServer('/api/order/stock')
export const occupation = new OccupationServer('/api/order/occupy')
export const intoAndManagement = new IntoAndManagementService('/api/procure/supplier/invoice')
export const salesDelivery = new SalesDeliveryServer('/api/order/delivery')
export const shipmentPackageDetails = new ShipmentPackageDetailsServer('/api/order/package')
// 订单参数设置
import { OrderParameterSettingsServer } from './orderParameterSettings'
export const orderParameterSettings = new OrderParameterSettingsServer('/api/order/orderParameterSettings')

// 销售退货单管理
import { AfterSalesReturnService } from './afterSalesReturn'
export const afterSalesReturn = new AfterSalesReturnService('/api/order/afterSales/return')
